var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":this.$store.getters.viewCompanyLink(_vm.companyId)}},[_c('app-button',{attrs:{"color":"danger"}},[_vm._v("Cancel")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }